import React from 'react';
import { Icon, Row, Col } from 'antd';
import 'antd/dist/antd.css';
import './index.css';
import '../../scripts/config'

class FooterContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="footer-container">
                <Row>
                    <Col span={24} style={{ textAlign: "center" }}>
                        Copyright&nbsp;&nbsp;<Icon type="copyright"></Icon>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {global.constants.year}-{global.constants.year}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <a href={global.constants.url} target="_blank">
                            {global.constants.companyname}
                        </a>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default FooterContainer;